import { TagType } from '@/components/v3/tag';

export interface Block {
  /** 唯一标识 */
  blockId: string;
  /** 标题 */
  title?: string;
  /** 导航标题 */
  navText?: string;
  /** 导航跳转 */
  navLink?: string;
  /** 排序 */
  sort: number;
}

export interface Tag {
  /** 文案 */
  text: string;
  /** 类型 */
  type: TagType;
}

export interface Activity {
  /** id唯一，可用于上报 */
  id: string
  /** 标题 */
  title: string;
  /** 描述 */
  desc: string;
  /** 标签 */
  tagList: Tag[];
  /** logo图片 */
  logo: string;
  /** 跳转链接 */
  url: string;
  /** 背景色 */
  bgColor: string;
  /** 是否展示剩余天数 */
  isShowLeft: boolean;
  /** 开始时间 */
  startTime: Date;
  /** 结束时间 */
  endTime: Date;
}


export enum DescTimeType {
  /** 开始时间 */
  Start = 1,
  /** 结束时间 */
  End,
}

export interface BannerActivityCfg {
  /** id唯一，可用于上报 */
  id: number;
  /** 所属区块的id */
  blockId: string;
  /** 标题 */
  title: string;
  /** 图片 */
  img: string;
  /** 跳转链接 */
  url: string;
  /** 开始时间 */
  startTime: Date;
  /** 结束时间 */
  endTime: Date;
  /** 描述类型 */
  descTimeType: DescTimeType;
  /** 展示次序 */
  sort: number;
  /** 检查黑白名单配置 */
  checkCfg: ActCheckCfg;
}

export interface ActivityCfg {
  /** 活动信息 */
  activityData: Activity;
  /** 所属区块的id */
  blockId: string;
  /** 展示次序 */
  sort: number;
  /** 检查黑白名单配置 */
  checkCfg: ActCheckCfg;
}

/** 检查黑白名单配置 */
export interface ActCheckCfg {
  /** 活动加密串 */
  actListid: string;
  /** 校验用户是否可参与活动的校验类型，0黑名单 or 1白名单 */
  checkType: '0' | '1';
}

export interface ActBanner {
  /** id唯一，可用于上报 */
  id: number;
  /** 所属区块的id */
  blockId: string;
  /** 图片 */
  img: string;
  /** 跳转链接 */
  url: string;
  /** 开始时间 */
  startTime: Date;
  /** 结束时间 */
  endTime: Date;
}

export interface Text {
  /** 文案 */
  text: string;
  /** 字体样式 */
  font?: string;
  /** 字体颜色 */
  color?: string;
}

export interface Information {
  /** 配置id。用于上报 */
  id: number;
  /** 标题 */
  title: string;
  /** 描述 */
  desc: string;
  /** 标签 */
  tagList: Tag[];
  /** logo图片 */
  logo: string;
  /** 跳转链接 */
  url: string;
  /** 开始时间 */
  startTime: Date;
  /** 结束时间 */
  endTime: Date;
  /** 展示次序 */
  order: number;
}


export interface Banner {
  /** 配置的id，唯一性 */
  id: number;
  /** 图片 */
  img: string;
  /** 跳转链接 */
  url: string;
  /** 开始时间 */
  startTime: Date;
  /** 结束时间 */
  endTime: Date;
  /** 展示次序 */
  sort: number;
}

export enum AdType {
  /** 文案 */
  text = 1,
  /** 整图 */
  img = 2,
}

export interface Ad {
  /** 配置的id，唯一性 */
  id: number;
  /** 大屏广告图片 */
  maxImg: string,
  /** 横幅类型 */
  adType: AdType,
  /** 横幅banner图片，当adType为图片时，才有值 */
  adBanner: string,
  /** 商户logo */
  logo: string,
  /** 横幅标题 */
  title: string,
  /** 横幅描述 */
  desc: string,
  /** 横幅按钮文案 */
  btnText?: string,
  /** 跳转链接 */
  url: string,
  /** 倒计时 */
  cutdown: number,
  /** 大屏开始时间 */
  largeStartTime: Date;
  /** 大屏结束时间 */
  largeEndTime: Date;
  /** 是否展示大屏banner */
  isShowLarge: Boolean;
  /** 大屏banner每日可展示次数 */
  daliyShowCnt: number;
  /** 大屏banner展示周期 */
  showLargePeriod: number;
  /** 大屏banner每周期可展示次数 */
  largePeriodShowLimit: number;
  /** 横幅开始时间 */
  smallStartTime: Date;
  /** 横幅结束时间 */
  smallEndTime: Date;
  /** abt实验规则分组id */
  abtestGroup: string;
  /** 回到首页按钮文字颜色 */
  backBtnColor: string;
}

export interface DiscountNotice {
  /** 奖品名 */
  name: string;
  /** 数量 */
  count: number;
  /** 时间 */
  time: string;
}

/**
 * ABTest分流配置
 */
export interface ABTestDivertCfg {
  /** 实验开始时间 */
  abtStartTime: Date;
  /** 实验结束时间 */
  abtEndTime: Date;
  /** 实验组ID */
  abtModuleSet: string;
  /** 实验组匹配规则 */
  abtestGroupConfig: ABTestGroupConfig[];
}

export interface ABTestGroupConfig {
  /** 分流开始时间 */
  startTime: Date;
  /** 结束时间 */
  endTime: Date;
  groupData: {
    /** 分组id */
    group: string;
    /** abtestId集合 */
    abtestID: string;
  }[];
  /** 实验时间内如果ABT接口挂了/或者是没命中匹配规则中的任意组，则返回兜底组 */
  defaultGroup?: string;
}

/**
 * 小喇叭数据类型
 */
export enum NoticeItemType {
  /** 电子印花 */
  EStamp = 'estamp',
  /** 优惠券 */
  Coupon = 'Coupon',
  /** 普通 */
  Common = 'common',
}

/**
 * 小喇叭列表项
 */
export interface NoticeItem {
  /** 左边内容 */
  content: string;
  /** 右边内容 */
  rightContent?: string,
  /** 跳转地址  */
  url?: string;
  /** 点击函数 */
  click?: Function;
  /** 数据类型  */
  type?: NoticeItemType,
  /** 额外的数据 */
  extra?: Object
}
